import { createAction } from "@reduxjs/toolkit";

const addAreasListAsyncAction = createAction("ADD_AREAS_LIST_ASYNC");

export default addAreasListAsyncAction;
